export default function ProductCarriers() {
  return [
    {
      carrierName: "",
      displayOrder: 1,
      logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/corebridge.png",
    },
    {
      carrierName: "",
      displayOrder: 2,
      logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/mutual-of-omaha.png",
    },
    {
      carrierName: "",
      displayOrder: 3,
      logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/transamerica.png",
    }
  ]
}